import { Skeleton } from "@/components/ui/feedback/skeleton";

export function HeaderSkeleton() {
  return <Skeleton className="w-24 h-10" />;
}

HeaderSkeleton.displayName = "Header.Skeleton";
